import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHeader } from "./fordon";
import { COMPARISONS } from "@/data/husbil-comparisons";

export const Route = createFileRoute("/jamfor/")({
  head: () => ({
    meta: [
      { title: "Husbils­jämförelser — Rapido, Hymer, Adria vs | AK Husbil" },
      { name: "description", content: "Alla våra husbils­jämförelser: Rapido V62 vs V68, Rapido vs Hymer, halvintegrerad vs integrerad, litium vs AGM. Neutrala guider från branschexperter." },
      { property: "og:title", content: "Husbils­jämförelser — modell mot modell | AK Husbil" },
      { property: "og:description", content: "Neutrala jämförelser: Rapido, Hymer, Adria, Bürstner. Pris, isolering, för/nack." },
      { property: "og:url", content: "https://www.akhusbilfritid.se/jamfor" },
    ],
    links: [{ rel: "canonical", href: "https://www.akhusbilfritid.se/jamfor" }],
  }),
  component: JamforIndex,
});

function JamforIndex() {
  const grouped = COMPARISONS.reduce<Record<string, typeof COMPARISONS>>((acc, c) => {
    (acc[c.category] ||= []).push(c);
    return acc;
  }, {});
  return (
    <>
      <PageHeader label="Jämförelser" title="Husbils­jämförelser" sub="Modell mot modell, teknik mot teknik" />
      <main className="max-w-4xl mx-auto px-4 py-10 space-y-10">
        {Object.entries(grouped).map(([cat, list]) => (
          <section key={cat}>
            <h2 className="text-xl font-bold mb-4">{cat}</h2>
            <div className="grid sm:grid-cols-2 gap-3">
              {list.map((c) => (
                <Link
                  key={c.slug}
                  to="/jamfor/$slug"
                  params={{ slug: c.slug }}
                  className="rounded-lg border p-4 hover:border-primary hover:bg-muted/40"
                >
                  <div className="font-semibold">{c.aName} <span className="text-muted-foreground">vs</span> {c.bName}</div>
                  <div className="text-sm text-muted-foreground mt-1 line-clamp-2">{c.winner}</div>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </main>
    </>
  );
}
